import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-wizard', 'completedStep', 'Pabeigts solis');
Labels.set('ui-wizard', 'next', 'Nākamais');
Labels.set('ui-wizard', 'back', 'Atpakaļ');
Labels.set('ui-wizard', 'cancel', 'Atcelt');
